import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
// import ModelSetSlideTable from '../ModelSetSlideTable';
import { Slide } from '../../../_data';
import { getSlideField } from '../../../utils';
import { SlideSubtitle } from '../slide-subtitle/slide-subtitle';
import SplitModelSetSlideTable from 'components/SplitModelSetSlideTable';
// import { PremiumReportModelSetSlideTable } from 'components/SplitModelSetSlideTable/wrappers';

export type StrategyAllocationProps = [
  {
    field: 'modelSetHoldings';
    label: string;
    value: any[];
    type: 'modelSetHoldings';
  },
];

export const StrategyAllocation = React.memo(
  ({
    slide,
  }: {
    slide: Slide<StrategyAllocationProps>;
  }): React.ReactElement => {
    return (
      <Grid container direction="row" className={styles.container}>
        <Grid item xs={12}>
          <SlideSubtitle>Strategy Allocations</SlideSubtitle>

          <Grid item xs={12} sx={{ width: '100%', marginTop: '16px' }}>
            {/* <ModelSetSlideTable
              key={
                getSlideField(slide, 'modelSetHoldings')?.value
                  ?.model_set_name || ''
              }
              slideMode
              action={{
                id: '',
                caseId: '',
                userId: '',
                milestoneId: '',
                versionName: '',
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                draft: false,
                value: {
                  model_set_holdings: [
                    getSlideField(slide, 'modelSetHoldings')?.value,
                  ],
                },
              }}
              modelSetName={
                getSlideField(slide, 'modelSetHoldings')?.value
                  ?.model_set_name || ''
              }
              maxHeight={480}
              fontSize={14}
              rowHeight={36}
            /> */}


            <SplitModelSetSlideTable
              key={
                getSlideField(slide, 'modelSetHoldings')?.value
                  ?.model_set_name || ''
              }
              data={{
                id: '',
                caseId: '',
                userId: '',
                milestoneId: '',
                versionName: '',
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                draft: false,
                value: {
                  model_set_holdings: [
                    getSlideField(slide, 'modelSetHoldings')?.value,
                  ],
                },
              }}
              modelSetName={
                getSlideField(slide, 'modelSetHoldings')?.value
                  ?.model_set_name || ''
              }
              slideMode={true}
              maxHeight={480}
              rowHeight={36}
              fontSize={12}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  },
);
